import { Component, computed, effect, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NavigationEnd, Router } from '@angular/router';
import { Nav } from '../../enums/nav.enum';
import { CommonModule } from '@angular/common';
import { StorageEnum } from '../../enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../services/storage.service';
import { AccountDetail } from '../../models/account-detail';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../services/util.service';
import { MatDividerModule } from '@angular/material/divider';
import { concatMap, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, MatDividerModule, MatExpansionModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  pageLabels: any;
  showFooter: boolean = false;
  showTelephone: boolean = false;
  accountDetail = new AccountDetail();
  categoryData: any;
  isMobile: boolean = false;
  env = environment;
  isPageLoading = computed(() => {
    if (this.utils.isSpinnerOnPage()) {
      return true;
    } else {
      return false;
    }
  });

  constructor(
    private readonly cmsS: CmsService,
    private readonly router: Router,
    private readonly storage: StorageService,
    private readonly utils: UtilService,
  ) {
    effect(() => {
      if (this.utils.updateNav()) {
        this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
      }
    });
  }

  ngOnInit(): void {
    // testing builder changes
    this.isMobile = this.utils.isMobile(992);
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        this.isMobile = this.utils.isMobile(992);
      });
    }
    this.cmsS
      .getContent('oas-footer', 'Footer')
      .pipe(
        concatMap((data: any) => {
          if (!this.utils.isNullOrUndefined(data)) {
            this.pageLabels = this.cmsS.flattenBuilderReferencesPreservingKeys(data);
            return this.cmsS.getFooterCategory();
          } else {
            return of('no category');
          }
        }),
        concatMap((footerCategory: any) => {
          if (footerCategory !== 'no category') {
            this.categoryData = this.cmsS.flattenBuilderReferencesPreservingKeys(footerCategory.results);
            return this.cmsS.getFooterLinks();
          } else {
            return of({});
          }
        }),
      )
      .subscribe((footerLinks: any) => {
        if (
          !this.utils.isNullOrUndefined(this.pageLabels) &&
          !this.utils.isNullOrUndefined(this.pageLabels.category) &&
          !this.utils.isNullOrUndefined(footerLinks)
        ) {
          this.pageLabels.category = this.removeOASDomainFromFooterLinks(
            this.categoryData,
            this.cmsS.flattenBuilderReferencesPreservingKeys(footerLinks.results),
          );
          this.setFooterData();
        }

        this.router.events.subscribe((event: any) => {
          if (event instanceof NavigationEnd) {
            switch (true) {
              case event.urlAfterRedirects.includes(Nav.Login):
              case event.urlAfterRedirects.includes(Nav.Register):
              case event.urlAfterRedirects.includes(Nav.RegisterAccount):
              case event.urlAfterRedirects.includes(Nav.Forgot):
              case event.urlAfterRedirects.includes(Nav.UpdateLoginInfo):
              case event.urlAfterRedirects.includes(Nav.OneTimePayment):
              case event.urlAfterRedirects.includes(Nav.OneTimePaymentSuccess):
              case event.urlAfterRedirects.includes(Nav.AccountLookup):
              case event.urlAfterRedirects.includes(Nav.Outage):
              case event.urlAfterRedirects.includes(Nav.Reset):
              case event.urlAfterRedirects.includes(Nav.AppError):
                this.showFooter = false;
                break;
              case event.urlAfterRedirects.includes(Nav.MultiAccountSummary):
                this.showFooter = true;
                this.showTelephone = false;
                break;
              case event.urlAfterRedirects.includes(Nav.Closed):
              case event.urlAfterRedirects.includes(Nav.Seasonal):
                this.showTelephone = true;
                this.showFooter = true;
                break;
              default:
                this.showTelephone = true;
                this.showFooter = true;
                break;
            }
          }
        });
      });
  }

  setFooterData(): void {
    this.pageLabels.telephoneLinkRes = this.pageLabels.contactInfoLinks.find((el: any) => {
      return el.telephoneType === 'Residential/Small Commercial';
    });
    this.pageLabels.telephoneLinkLrg = this.pageLabels.contactInfoLinks.find((el: any) => {
      return el.telephoneType === 'Large Commercial';
    });

    // hours of operation
    this.pageLabels.hoursOfOperation = this.pageLabels.hoursOfOperation.replaceAll('\n', '<br>');
  }

  mergeCategoriesWithLinks(categories: any[], links: any[]): any[] {
    return categories.map((category) => ({
      ...category,
      links: links.filter((link) => link.data.category.name === category.data.name),
    }));
  }

  removeOASDomainFromFooterLinks(categories: any[], links: any[]): any[] {
    const newList = this.mergeCategoriesWithLinks(categories, links);
    return newList.map((linkArray: any) => {
      linkArray.links.map((link: any) => {
        if (link.data.link.includes(this.env.manageAccountUrl)) {
          // Remove domain from the string
          // eslint-disable-next-line no-useless-escape
          const cleanedUrl = link.data.link.replace(this.env.manageAccountUrl, '');

          const newLinkWithoutDomain = { ...link, link: (link.data.link = cleanedUrl) };

          return newLinkWithoutDomain;
        } else {
          const regularLink = { ...link, link: (link.data.link = this.env.websiteBaseUrl + link.data.link) };

          return regularLink;
        }
      });
      return linkArray;
    });
  }
}
